// extracted by mini-css-extract-plugin
module.exports = {"calendar":"_1y8L9","mobile":"_1pTOy"};